export default __webpack_public_path__ + "static/media/book-nav-check-icon.89da71e2.svg";